import React, { useEffect, useState } from 'react';
import moment from 'moment';

const StrategistTable = (props) => {

    const [stageList, setStageList] = useState([]);

    useEffect(() => {
        // console.log(props, 'data ')
        if (props.strategist) {
            setStageList(props?.strategist)
        }
    }, [props?.strategist]);

    return (
        <>
            <h5 className='py-3'><strong>Current Managers</strong></h5>
            <table className="table table-hover table-custom mb-0">
                <thead className="">
                    <tr>
                        <th>Manager Name</th>
                        <th>Status</th>
                        <th>Created At</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        stageList && stageList.map((stage, index) => (
                            <tr key={index}>
                                <td>{stage?.strategist_name || 'N/A'}</td>
                                <td>{stage?.status || 'N/A'}</td>
                                <td>{moment(stage.createdAt).format('DD/MM/YYYY') || 'N/A'}</td>
                                <td className='text-center'>
                                    {props?.isClientPartner && !stage.is_accepted ? <button className="btn btn-sm round btn-outline-danger" onClick={() => props.deleteTimelineModalShow(stage, 'Strategist')}>Delete</button> : null}
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </table>
            {!stageList.length ? <div className='text-center font-weight-bold pt-3'>No Records</div> : null}
        </>
    );
};
export default StrategistTable;